// extracted by mini-css-extract-plugin
export default {"wrapper":"addQuestion_wrapper__f-6BH","text_ansver_box":"addQuestion_text_ansver_box__U8NLa","text_box":"addQuestion_text_box__r8H+9","imgQuiz":"addQuestion_imgQuiz__DAuoX"};